import { useRouter } from 'next/navigation';
import PriceListCard from './price-list-card';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useState } from 'react';
import { CurriculumAccessPaymentDialog } from '../profile/curriculum-access-payment-dialog';
import { useQuery } from '@tanstack/react-query';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { fetchPaymentTypes } from '@eliadmin/core/src/api/jobportal/offers-api';

export const PriceListCompany = () => {
  const router = useRouter();
  const { me } = useCustomerStore();
  const locale = useLocaleStore(state => state.currentLocale);

  const { data: payments } = useQuery({
    queryKey: ['cart-payments'],
    queryFn: () => fetchPaymentTypes({ locale, authToken: me?.authToken || '' }).then(r => r.data),
  });

  const [isOpenCurriculumAccessDialog, setIsOpenCurriculumAccessDialog] = useState(false);

  return (
    <div className="space-y-8">
      {/* Prístup k životopisom Section */}
      <div>
        <h2 className="mb-6 text-2xl font-bold text-gray-900">Prístup k životopisom</h2>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <PriceListCard
            title="Prístup k životopisom"
            description="1 mesiac + 15 životopisov"
            price="70 € bez DPH"
            buttonText="Zakúpiť"
            buttonAction={() => {
              setIsOpenCurriculumAccessDialog(true);
            }}
          />
          <PriceListCard
            title="Prístup k životopisom"
            description="1 mesiac + 30 životopisov"
            price="120 € bez DPH"
            buttonText="Zakúpiť"
            buttonAction={() => {
              setIsOpenCurriculumAccessDialog(true);
            }}
          />
          <PriceListCard
            title="Prístup k životopisom"
            description="1 mesiac + 50 životopisov"
            price="180 € bez DPH"
            buttonText="Zakúpiť"
            buttonAction={() => {
              setIsOpenCurriculumAccessDialog(true);
            }}
          />
        </div>
      </div>

      {/* Zverejnenie pracovnej ponuky Section */}
      <div>
        <h2 className="mb-6 text-2xl font-bold text-gray-900">Zverejnenie pracovnej ponuky</h2>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <PriceListCard
            title="Zverejnenie pracovnej ponuky"
            description="1 mesiac"
            price="80.00 € bez DPH"
            buttonText="Zakúpiť"
            buttonAction={() => {
              me?.authToken ? router.push(ROUTES.PROFILE()) : router.push(ROUTES.SIGN_IN());
            }}
          />
          <PriceListCard
            title="Zverejnenie pracovnej ponuky"
            description="2 mesiace"
            price="140.00 € bez DPH"
            buttonText="Zakúpiť"
            buttonAction={() => {
              me?.authToken ? router.push(ROUTES.PROFILE()) : router.push(ROUTES.SIGN_IN());
            }}
          />
          {/* <PriceListCard
            title="Zverejnenie 2 ponúk"
            description="1 mesiac"
            price="140.00 €"
            buttonText="Zakúpiť"
            buttonAction={() => {
              me?.authToken ? router.push(ROUTES.PROFILE()) : router.push(ROUTES.SIGN_IN());
            }}
          />
          <PriceListCard
            title="Zverejnenie 2 ponúk"
            description="2 mesiace"
            price="240.00 €"
            buttonText="Zakúpiť"
            buttonAction={() => {
              me?.authToken ? router.push(ROUTES.PROFILE()) : router.push(ROUTES.SIGN_IN());
            }}
          /> */}
          {/* <PriceListCard
            title="Zverejnenie pracovnej ponuky"
            description="2 mesiace"
            price="80.00 € bez DPH"
            buttonText="Zakúpiť"
            buttonAction={() => {
              me?.authToken ? router.push(ROUTES.PROFILE()) : router.push(ROUTES.SIGN_IN());
            }}
          /> */}
        </div>
      </div>

      {/* Zvýraznenie pracovnej ponuky Section */}
      <div>
        <h2 className="mb-6 text-2xl font-bold text-gray-900">Zvýraznenie pracovnej ponuky</h2>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <PriceListCard
            title="Presunutie pracovnej ponuky na popredné miesto"
            description="1 mesiac"
            price="90.00 € bez DPH"
            buttonText="Zakúpiť"
            buttonAction={() => {
              me?.authToken ? router.push(ROUTES.PROFILE()) : router.push(ROUTES.SIGN_IN());
            }}
          />
          <PriceListCard
            title="Presunutie pracovnej ponuky na popredné miesto + DREAM JOB"
            description="1 mesiac"
            price="150.00 € bez DPH"
            buttonText="Zakúpiť"
            buttonAction={() => {
              me?.authToken ? router.push(ROUTES.PROFILE()) : router.push(ROUTES.SIGN_IN());
            }}
          />
          <PriceListCard
            title="Presunutie pracovnej ponuky na popredné miesto + IMMEDIATE JOB"
            description="1 mesiac"
            price="150.00 € bez DPH"
            buttonText="Zakúpiť"
            buttonAction={() => {
              me?.authToken ? router.push(ROUTES.PROFILE()) : router.push(ROUTES.SIGN_IN());
            }}
          />
        </div>
      </div>

      {/* Individuálna ponuka Section */}
      <div>
        <h2 className="mb-6 text-2xl font-bold text-gray-900">Individuálna ponuka</h2>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <PriceListCard
            title="Individuálna ponuka"
            description="Pripravíme vám ponuku na mieru podľa vašich požiadaviek."
            price="Na vyžiadanie"
            buttonText="Získať ponuku"
            buttonAction={() => {
              router.push('/individualna-ponuka');
            }}
          />
        </div>
      </div>

      <CurriculumAccessPaymentDialog
        open={isOpenCurriculumAccessDialog}
        setOpen={setIsOpenCurriculumAccessDialog}
        payments={payments}
      />
    </div>
  );
};
